import isEqual from 'lodash/isEqual';
export const _isEqual = isEqual;
